import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageChangeService {
  private readonly defaultLang = 'en'; // Default to English

  constructor(private readonly translate: TranslateService) {
    // Set default language
    this.translate.setDefaultLang(this.defaultLang);

    let localStorageLang: string = this.defaultLang;

    // Initialize translation with the chosen language
    this.translate.use(localStorageLang).subscribe(() => {
    });
  }

  switchLanguage(language: string) {
    // Allow 'en', 'jp', or 'zh-CN' only
    const validLang = (language === 'jp' || language === 'zhCN') ? language : 'en';
    this.translate.use(validLang).subscribe(() => {
      // Persist language choice in localStorage
      localStorage.setItem('lang', validLang);
    });
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || 'en';
  }
}